<template>
  <v-app-bar flat dense class="grey lighten-2">
    <v-avatar
      @click="$router.push({ name: 'CHPPRoot.Home' })"
      size="30"
      class="ma-2"
    >
      <v-img src="@/assets/freed-small-logo.svg" size="30" />
    </v-avatar>
    <v-spacer></v-spacer>
     <v-btn text @click="$router.push({ name: 'CHPPRoot.Home' })">
        ELIGIBLE
      </v-btn>

      <v-btn text @click="$router.push({ name: 'CHPPRoot.Ineligible' })">
        INELIGIBLE
      </v-btn>
    <v-spacer></v-spacer>
    
    <app-bar-user-menu />
    
  </v-app-bar>
</template>

<script lang="ts">
import { Vue, Component, Watch } from "vue-property-decorator";
import Helper from "../../util/Helper";
import store, * as Store from "@/../src-gen/store";
import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";

import FClientFileAutoCompleteField from "@/components/form/field/FClientFileAutoCompleteField.vue";
import AppBarUserMenu from "./ChppAppBarUserMenu.vue";

@Component({
  components: {
    AppBarUserMenu,
    
    FClientFileAutoCompleteField,
  },
})
export default class CHPPAppBar extends Vue {
  @Store.Getter.Login.LoginDetails.roleList
  roleList: string[];

  
  selectedClientFileNumber: string = "";
 

 

  get isSalesRep() {
    return this.roleList.includes("SalesRep");
  }

  get isSalesLead() {
    return this.roleList.includes("SalesLead");
  }


  goto(routerName: string) {
    this.$router.push({ name: routerName });
  }

  openInNewTab(route: string) {
    const routeData = this.$router.resolve({ name: route });
    const routeHref = routeData.href.split("/").slice(-3).join("/");
    window.open(routeHref, "_blank");
  }

}
</script>

<style scoped></style>
